<template>
  <router-link :to="link" class="card">
    <div class="card__header">
      <div class="card__header-preview" v-if="preview" :style="{backgroundImage: `url(${preview})`}"></div>
      <!--
      <img
          v-if="preview"
          class="card__header-preview"
          :src="preview"
          :alt="title"
      >
      -->
      <div class="rate" v-if="rate">
        <img src="@/assets/images/icons/star.svg" alt="">
        <span>{{ rate }}</span>
      </div>
    </div>
    <div class="card__body">
      <div class="card__title" v-if="title">{{ title }}</div>
      <div class="card__tags" v-if="tags && tags.length">
        <tag :key="idx" v-for="(tag, idx) in tags">{{ tag.name }}</tag>
      </div>
      <slot name="address"></slot>
      <address-component v-if="address">{{ address }}</address-component>
    </div>
  </router-link>
</template>

<script>
import Tag from '../text/tag'
import AddressComponent from '../text/address-component'

export default {
  name: 'card',
  components: {AddressComponent, Tag},
  props: {
    title: {
      type: String,
    },
    preview: {
      type: String,
    },
    rate: {
      type: Number,
    },
    address: {
      type: String,
    },
    link: {
      type: String,
    },
    tags: {
      type: Array,
    }
  },
}
</script>

<style scoped lang="scss">
.card {
  background-color: #fff;
  border-radius: 10px;
  display: block;
  width: 100%;
  text-decoration: none;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 30px;
  transition: 200ms transform ease, 200ms box-shadow ease;

  &__header {
    border-radius: 10px 10px 0 0;
    height: 200px;
    position: relative;

    &-preview {
      border-radius: 10px 10px 0 0;
      height: 100%;
      width: 100%;
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
    }

    .rate {
      position: absolute;
      bottom: 10px;
      right: 10px;
      background: #FFFFFF;
      border-radius: 5px;
      height: 40px;
      width: 63px;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.04);
      display: flex;
      align-items: center;
      padding-left: 6px;

      img {
        width: 20px;
        height: 20px;
      }

      span {
        font-family: "Open Sans", sans-serif;
        font-weight: 600;
        font-size: 20px;
        color: #383838;
        margin-left: 2px;
      }
    }

  }

  &__body {
    border-radius: 0 0 10px 10px;
    padding: 15px 20px 20px 20px;
  }

  &__title {
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 1.4;
    color: #383838;
    margin-bottom: 10px;
  }

  &__tags {
    margin: 0 -10px 10px -10px;
    display: flex;
    flex-wrap: wrap;
  }

  &:hover {
    opacity: 1;
    transform: translateY(-10px);
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 24px 32px rgba(0, 0, 0, 0.04);
  }
}

@media screen and (max-width: 991px) {
  .card {
  }
}
</style>
